<script>
import Properties from '@/extensions/shop/views/Product/Form/Partials/Properties'

export default {
    name: 'PropertiesStep',
    extends: Properties,
    methods: {
        setPropSet(propSet) {
            this.form.propSet = propSet
        },
        setPropertyPivot(propertyPivot) {
            // propertyPivot.valueOptions = _.orderBy(this.modal.form.valueOptions, 'value', 'asc')
            propertyPivot.valueOptions = _.cloneDeep(this.modal.form.valueOptions)
        },
        setPropertyPivots(propertyPivots) {
            this.form.propertyPivots = propertyPivots
        },
        deletePropertyPivot(propertyPivot) {
            const i = _.findIndex(this.form.propertyPivots, el => el.id === propertyPivot.id)
            if (i >= 0) this.form.propertyPivots.splice(i, 1)
        },
        sortPropertyPivotValueOptions(event, propertyPivot) {
            const { newIndex, oldIndex } = event
            const valueOptions = propertyPivot.valueOptions
            const valueOption = valueOptions.splice(oldIndex, 1)[0]
            valueOptions.splice(newIndex, 0, valueOption)
        },
    }
}
</script>
